import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Checkbox from '../Checkbox/Checkbox';
import { treeClass } from './styles';
import { getDirectionClass } from '../utils/classname';

var TreeCheckbox =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TreeCheckbox, _PureComponent);

  var _super = _createSuper2(TreeCheckbox);

  function TreeCheckbox(props) {
    var _this;

    _classCallCheck(this, TreeCheckbox);

    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    props.datum.bind(props.id, _this.forceUpdate.bind(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(TreeCheckbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(TreeCheckbox.prototype), "componentDidMount", this).call(this); // When dragging a node,
      // it will first trigger the constructor of the new node,
      // then trigger the willUnmount of the old node,
      // and finally trigger the didMount of the new node,
      // the old node will unload the update event, so bind it here again


      this.props.datum.bind(this.props.id, this.forceUpdate.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(TreeCheckbox.prototype), "componentWillUnmount", this).call(this);

      this.props.datum.unbind(this.props.id);
    }
  }, {
    key: "checkDisabled",
    value: function checkDisabled() {
      var _this$props = this.props,
          datum = _this$props.datum,
          id = _this$props.id,
          disabled = _this$props.disabled;
      if (disabled) return true;
      return datum.isDisabled(id);
    }
  }, {
    key: "handleChange",
    value: function handleChange(_, checked) {
      var _this$props2 = this.props,
          datum = _this$props2.datum,
          id = _this$props2.id,
          onChange = _this$props2.onChange;
      datum.set(id, checked ? 1 : 0);
      onChange(datum.getValue(), id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          datum = _this$props3.datum,
          id = _this$props3.id;
      var checked = datum.getChecked(id);
      return (
        /*#__PURE__*/
        React.createElement(Checkbox, {
          checked: checked,
          disabled: this.checkDisabled(),
          onChange: this.handleChange,
          className: treeClass(getDirectionClass('checkbox'))
        })
      );
    }
  }]);

  return TreeCheckbox;
}(PureComponent);

export { TreeCheckbox as default };